/**
 * Layout — App Shell (design §7.1).
 * Fixed sidebar + sticky topbar (Navbar) + animated content + Footer.
 * Toaster lives in App (survives logout → /login).
 */
import { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { AnimatedOutlet } from './AnimatedOutlet';
import { DocumentTitle } from './DocumentTitle';
import { MOBILE_CONTENT_PB } from '@/lib/shell';
import { scheduleShellPrefetch } from '@/lib/prefetch-routes';

export default function Layout() {
  useEffect(() => scheduleShellPrefetch(), []);

  return (
    <Navbar>
      <DocumentTitle />
      <main className={`mx-auto w-full max-w-[1180px] flex-1 px-4 pt-7 md:px-8 print:px-0 print:pt-0 ${MOBILE_CONTENT_PB}`}>
        <AnimatedOutlet />
      </main>
      <Footer />
    </Navbar>
  );
}
